/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, GarageSpotFromJSON, GarageSpotToJSON, GarageSpotAttributeDefinitionFromJSON, GarageSpotAttributeDefinitionToJSON, } from './';
export function GarageSpotAttributeFromJSON(json) {
    return GarageSpotAttributeFromJSONTyped(json, false);
}
export function GarageSpotAttributeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'garageSpot': !exists(json, 'garageSpot') ? undefined : GarageSpotFromJSON(json['garageSpot']),
        'garageSpotId': !exists(json, 'garageSpotId') ? undefined : json['garageSpotId'],
        'attributeDefinition': !exists(json, 'attributeDefinition') ? undefined : GarageSpotAttributeDefinitionFromJSON(json['attributeDefinition']),
        'attributeDefinitionId': !exists(json, 'attributeDefinitionId') ? undefined : json['attributeDefinitionId'],
    };
}
export function GarageSpotAttributeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'value': value.value,
        'garageSpot': GarageSpotToJSON(value.garageSpot),
        'garageSpotId': value.garageSpotId,
        'attributeDefinition': GarageSpotAttributeDefinitionToJSON(value.attributeDefinition),
        'attributeDefinitionId': value.attributeDefinitionId,
    };
}
